export default __webpack_public_path__ + "static/media/TheWorldEgypt_01.00f73125.png";